export enum FinanceCalculatorEnvironment {
  Production = 'production',
  Test = 'test', // default
  Development = 'development' // there should be no need to actually use this environment
}
